import { NgxTippyProps } from 'ngx-tippy-wrapper';

export const TIPPY_PROPS: NgxTippyProps = {
  trigger: 'mouseenter focus click'
};
